<template>
  <div>
    <!-- 날짜 -->
    <div v-if="!!form.stdInfo.field_name" class="absolute top-0 flex items-center gap-4" :class="[!isPrint && 'py-6']" style="left: calc(180px + 1.5rem)">
      <div v-if="isPrint" class="flex items-center justify-center gap-3">
        <p class="print-input">{{ form.headerDate | moment("YYYY") }}</p>
        년
        <p class="print-input">{{ form.headerDate | moment("M") }}</p>
        월
      </div>
      <month-picker v-else class="inline-block" v-model="form.headerDate" :readonly="board.readonly" :disableYM="disableMonth">
        <template v-slot="{ inputValue, year, month, onClick }">
          <div class="flex items-center justify-center gap-3 cursor-pointer" @click="onClick">
            <ml-input style="width: 100px" class="header-month" :class="[board.readonly && 'readonly']" :value="year" readonly />
            <p>년</p>
            <ml-input style="width: 100px" class="header-month" :class="[board.readonly && 'readonly']" :value="month" readonly />
            <p>월</p>
          </div>
        </template>
      </month-picker>
    </div>

    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" @selectField="loadApprovalPostList" />

    <div>
      <h5 class="mt-6 mb-4"><i class="dot"></i>산업안전보건관리비</h5>
      <table class="mb-6">
        <colgroup>
          <col style="background: #f9f9f9" />
          <col width="340" style="background: #f9f9f9" />
        </colgroup>
        <thead>
          <tr>
            <th rowspan="2">편성기준</th>
            <th rowspan="2">항목</th>
            <th colspan="4">예산</th>
            <th rowspan="2">지출액</th>
            <th rowspan="2">지출잔액</th>
            <th rowspan="2">집행률</th>
          </tr>
          <tr>
            <th>편성액</th>
            <th>본예산</th>
            <th>추경예산</th>
            <th>결산추경</th>
          </tr>
        </thead>
        <tbody>
          <fragment v-for="(budget, budget_i) in form.budgetList" :key="budget.label">
            <tr v-for="(item, item_i) in budget.list" :key="`${budget.label}_${item.label}`">
              <td v-if="item_i === 0" :rowspan="budget.list.length">{{ budget.label }}</td>
              <td class="text-center">{{ item.label }}</td>
              <td><CommaInput :isPrint="isPrint" readonly class="w-full" placeholder="자동입력" :value="item.편성액" /></td>
              <td><CommaInput :isPrint="isPrint" class="w-full" placeholder="숫자입력" v-model="item.본예산" @blur="calculData(budget_i, item_i)" /></td>
              <td><CommaInput :isPrint="isPrint" class="w-full" placeholder="숫자입력" v-model="item.추경예산" @blur="calculData(budget_i, item_i)" /></td>
              <td><CommaInput :isPrint="isPrint" class="w-full" placeholder="숫자입력" v-model="item.결산추경" @blur="calculData(budget_i, item_i)" /></td>
              <td><CommaInput :isPrint="isPrint" class="w-full" placeholder="숫자입력" v-model="item.지출액" @blur="calculData(budget_i, item_i)" /></td>
              <td><CommaInput :isPrint="isPrint" readonly class="w-full" placeholder="자동입력" :value="item.지출잔액" /></td>
              <td><ml-input readonly class="w-full" placeholder="자동입력" :value="item.집행률" /></td>
            </tr>
          </fragment>
          <tr>
            <td colspan="2">계</td>
            <td><CommaInput :isPrint="isPrint" readonly class="w-full" placeholder="자동입력" :value="form.totalBudget.편성액" /></td>
            <td><CommaInput :isPrint="isPrint" readonly class="w-full" placeholder="자동입력" :value="form.totalBudget.본예산" /></td>
            <td><CommaInput :isPrint="isPrint" readonly class="w-full" placeholder="자동입력" :value="form.totalBudget.추경예산" /></td>
            <td><CommaInput :isPrint="isPrint" readonly class="w-full" placeholder="자동입력" :value="form.totalBudget.결산추경" /></td>
            <td><CommaInput :isPrint="isPrint" readonly class="w-full" placeholder="자동입력" :value="form.totalBudget.지출액" /></td>
            <td><CommaInput :isPrint="isPrint" readonly class="w-full" placeholder="자동입력" :value="form.totalBudget.지출잔액" /></td>
            <td><ml-input readonly class="w-full" placeholder="자동입력" :value="form.totalBudget.집행률" /></td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import Print from "./Print.vue";
import moment from "moment";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    Print,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    isPostId() {
      return !!this.$route.params.postId;
    },
    postList() {
      return this.$store.state.approval.list.map((item) => this.getContent(item));
    },
    disableMonth() {
      return this.postList.map((item) => moment(item.headerDate).format("YYYY-M"));
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created () {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  data() {
    return {
      form: {
        headerDate: "",
        stdInfo: {},
        totalBudget: {
          편성액: 0,
          본예산: 0,
          추경예산: 0,
          결산추경: 0,
          지출액: 0,
          지출잔액: 0,
          집행률: 0,
        },
        budgetList: [
          {
            label: "인건비",
            list: [
              {
                label: "전담인력",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
              {
                label: "기간제 근로자",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
              {
                label: "공무직근로자",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
            ],
          },
          {
            label: "유해 위험 요인 개선",
            list: [
              {
                label: "위험성평가 용역비",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
              {
                label: "근골격계유해요인조사용역비",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
              {
                label: "작업환경측정용역비",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
              {
                label: "안전보건진단, 위탁 및 컨설팅비용",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
              {
                label: "설비 및 시설물에 대한 안전점검비용",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
            ],
          },
          {
            label: "중대 재해 예방 활동 및 교육",
            list: [
              {
                label: "안전보건교육비",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
              {
                label: "안전보건관리 위탁수수료",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
              {
                label: "안전보건포상비용",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
              {
                label: "안전관련 설명서및 매뉴얼제작",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
              {
                label: "안전관련 홍보물 제작",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
              {
                label: "중대재해예방 캠페인",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
            ],
          },
          {
            label: "근로자 안전보건 관리",
            list: [
              {
                label: "안전보건관리 물품및 장비구입",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
              {
                label: "특수건강검진",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
              {
                label: "건강관리실 운영비",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
            ],
          },
          {
            label: "기타",
            list: [
              {
                label: "그외 안전보건예산",
                편성액: "",
                본예산: "",
                추경예산: "",
                결산추경: "",
                지출액: "",
                지출잔액: "",
                집행률: "",
              },
            ],
          },
        ],
        fileList: [],
      },
    };
  },
  created() {
    if (this.isPostId) {
      this.loadApprovalPostList();
    }
  },
  methods: {
    async loadApprovalPostList() {
      const projectId = this.$route.params.proj_id;
      const boardSlug = "board-437";
      const page = 1;
      const perPage = 10000;
      const keyword = [`content$body.stdInfo.field_name*${this.form.stdInfo.field_name}`];

      await this.$store.dispatch("approval/LOAD_POST_COMPLETE", { projectId, boardSlug, page, perPage, keyword });

      let month = moment(new Date()).format("YYYY-M");
      while (this.disableMonth.includes(month)) {
        month = moment(month).add(1, "months").format("YYYY-M");
      }

      if (!this.isPostId) this.form.headerDate = month;
    },
    calculData(budgetIndex, listIndex) {
      const item = this.form.budgetList[budgetIndex].list[listIndex];
      item.편성액 = item.본예산 + item.추경예산 + item.결산추경;
      item.지출잔액 = item.편성액 - item.지출액;
      item.집행률 = !!item.지출액 && !!item.편성액 ? (item.지출액 / item.편성액).toFixed(2) : "";

      this.totalSet();
    },
    totalSet() {
      this.form.totalBudget = this.form.budgetList.reduce(
        (prevBudgetItem, budgetItem) => {
          const totalItem = budgetItem.list.reduce(
            (prevItem, item) => {
              return {
                편성액: prevItem.편성액 + Number(item.편성액),
                본예산: prevItem.본예산 + Number(item.본예산),
                추경예산: prevItem.추경예산 + Number(item.추경예산),
                결산추경: prevItem.결산추경 + Number(item.결산추경),
                지출액: prevItem.지출액 + Number(item.지출액),
                지출잔액: prevItem.지출잔액 + Number(item.지출잔액),
                집행률: prevItem.집행률 + Number(item.집행률),
              };
            },
            {
              편성액: 0,
              본예산: 0,
              추경예산: 0,
              결산추경: 0,
              지출액: 0,
              지출잔액: 0,
              집행률: 0,
            }
          );

          return {
            편성액: prevBudgetItem.편성액 + totalItem.편성액,
            본예산: prevBudgetItem.본예산 + totalItem.본예산,
            추경예산: prevBudgetItem.추경예산 + totalItem.추경예산,
            결산추경: prevBudgetItem.결산추경 + totalItem.결산추경,
            지출액: prevBudgetItem.지출액 + totalItem.지출액,
            지출잔액: prevBudgetItem.지출잔액 + totalItem.지출잔액,
            집행률: prevBudgetItem.집행률 + totalItem.집행률,
          };
        },
        {
          편성액: 0,
          본예산: 0,
          추경예산: 0,
          결산추경: 0,
          지출액: 0,
          지출잔액: 0,
          집행률: 0,
        }
      );
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.body;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.header-month::v-deep {
  input {
    background: white;
  }
  &.readonly input {
    background: #fafafa !important;
  }
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th {
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;

    background: #f9f9f9;
    border: 1px solid #cdcdcd;
    padding: 11px 0;
  }
  td {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 2px 4px;
  }

  tr > td:nth-child(n + 2) {
    text-align: left;
  }
}
</style>
